module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAAXNSR0IArs4c6QAAANxJREFUOE+V1N8NgjAQBvDvHnh3BEewgXdxA5xAHcVNcALjBL7DJV1BN8AByJkSJCD9e6/tr01635WQUE3T7LMseyulXhTjtNabvu/vAEqzX0QOQTiiJ4Dd7xIRuXqhDY346IQuRESXPM9rKwwhc+sKxqAVjEULmIImmIomyMx63qdhYXw9V0CImSsAJhVThdBwcNu2JRGZZMzrVhTF2RfHoR3MXAM4peCpj6l4EYAUvEpOLLZmNQY7pyOEvfPow8EfwIZNQILQ0edHFPzDHxGpoqHBWustgE4p1X0B206Vy6FeefMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/cpzx_z.png
// module id = qS4O
// module chunks = 1